$(document).ready(function(){
    theme = {
        init : function(){
            theme.asideAction();
            theme.relatedArticle();
            theme.productViewType();
            theme.removeProductCart();
            theme.quickView();
            theme.singleProduct();
            theme.removeCompareId();
            theme.viewCompare();
            theme.relatedProduct();
            theme.navProduct();
            theme.isotopeCollection();
            theme.box();
            theme.close();
            theme.toggleMenu();
            theme.scroll();
        },
        asideAction : function(){
            $('.sidebar-overlay').on('click',function(){
                $(this).removeClass('active');
                $('.aside-shop').removeClass('active');
            })
        },
        relatedArticle : function(){
            $('.related-articles').owlCarousel({
                nav:false,
                dots:true,
                loop:false,
                autoplay:false,
                autoplayTimeout:false,
                margin:40,
                responsive: {
                    0: {
                        items: 1
                    },
                    640:{
                        items: 2
                    },
                    768: {
                        items: 2
                    },
                    992: {
                        items: 3
                    },
                    1200: {
                        items: 3
                    }
                }
            })
        },
        productViewType : function(){
            if($('.product-view-type').length > 0){
                var type = getCookie('_view_type');
                $('.product-view-type').removeClass('active');
                if(type != false){
                    $('.product-view.shop').removeClass('grid-product').addClass(type);
                    //$('.product-view').data('isotope',null);
                    $('[data-type="'+type+'"]').addClass('active');
                }else{
                    $('.product-view.shop').addClass('grid-product');
                    theme.isotopeCollection();
                    $('[data-type="grid-product"]').addClass('active');
                }
                $(document).on('click','.product-view-type',function(e){
                    e.preventDefault();
                    var type = $(this).data('type');
                    $(this).siblings('.product-view-type').removeClass('active');
                    $(this).addClass('active');
                    if(type == 'list-product'){
                        $('.product-view.shop').addClass(type).removeClass('grid-product');
                        //$('.product-view').data('isotope',null);
                    }else{
                        $('.product-view.shop').addClass(type).removeClass('list-product');
                        theme.isotopeCollection();
                    }
                    setCookie('_view_type',type,60);
                })
            }
        },
        removeProductCart : function(){
            $('.input-qty').on('change',function(){
                var num = parseInt($(this).data('current'));
                var val = parseInt($(this).val());
                if(num < val || val < num){
                    $('#button-update').removeAttr('disabled');
                }else{
                    $('#button-update').attr('disabled','disabled');
                }
            })
        },
        quickView : function(){
            $(document).on('click','.quick-view',function(e){
                e.preventDefault();
                var id = $(this).data('id');
                var product_name = $(this).data('name');
                if(id){
                    var html = $('.content-quick-view-'+id).html();
                    $('#modal-quick-view').find('.append').html(html);
                    $('#modal-quick-view').modal('show');
                    setTimeout(function(){
                        theme.navProduct();
                    },1500);
                    theme.actionProduct(product_name,false);
                }
            })
        },
        singleProduct : function(){
            if(typeof product_name != typeof undefined){
                theme.actionProduct(product_name,true);
            }
        },
        actionProduct : function(product_name,push){
            var single_product = $(document).find('.main-single-content-product');
            var data = [];
            $.ajax({
                type : "GET",
                url :'https://'+window.location.hostname+'/products/'+product_name+'.json',
                async : false,
                success : function(response){
                    data = response.product;
                }
            });
            var variants = data.variants;
            var select = '.product-variants';
            var inputs = $(document).find(select+' input');
            $(document).find('.image-variant').on('click',function(){
                var id = $(this).attr('id');
                for(var i = 0 ; i < variants.length;i++){
                    if(variants[i].image_id != null && id == variants[i].image_id){
                        theme.handleSelectVariant(single_product,variants[i],push);
                        console.log(variants[i]);
                        $('[value="'+variants[i].option1+'"]').prop('checked',true);
                        $('[value="'+variants[i].option2+'"]').prop('checked',true);
                        $('[value="'+variants[i].option3+'"]').prop('checked',true);
                        break;
                    }
                }
            });
            inputs.on('change',function () {
                theme.selectVariant(single_product, select, variants,push);
            });
        },
        selectVariant : function(single_product,select,variants,push){
            var option = [];
            var variant = [];
            var checked = $(select + " input:checked");
            checked.each(function () {
                option.push($(this).val());
            })
            option = option.join(',').toLowerCase().replace(/[^A-Z0-9]+/ig, "");
            for (var i in variants) {
                var vri = [variants[i].option1,variants[i].option2,variants[i].option3].join(',').toLowerCase().replace(/[^A-Z0-9]+/ig, "");
                if (vri === option) {
                    variant = variants[i];
                    break;
                }
            }
            theme.handleSelectVariant(single_product,variant,push);
        },
        handleSelectVariant : function(container,variant,state){
            if(variant) {
                var variant_id = $(container).find('[name="id"]');
                var price = $(container).find('.price');
                var wish = $(container).find('.add-wishlist');
                $(wish).attr('data-variant', variant.id);
                $(variant_id).val(variant.id);
                if(state == true){
                    window.history.pushState({}, '', '?variant=' + variant.id);
                }
                if (parseFloat(variant.compare_at_price) > parseFloat(variant.price)) {
                    $(price).find('.no-sale').html('<span class="money" data-currency-' + shop_currency + '="' + money_format + (variant.compare_at_price)  + '">' + money_format + (variant.compare_at_price) + '</span>').show();
                    $(price).find('.sale').html('<span class="money" data-currency-' + shop_currency + '="' + money_format + (variant.price) + '">' + money_format + (variant.price) + '</span>');
                } else {
                    $(price).find('.no-sale').hide();
                    $(price).find('.sale').html('<span class="money" data-currency-' + shop_currency + '="' + money_format + (variant.price) + '">' + money_format + (variant.price) + '</span>');
                }

                if (variant.image_id != null) {
                    var id = variant.image_id;
                    $(container).find('[data-id="'+id+'"]').trigger('click');
                }
                theme.wishlist(container, variant.id);
            }
        },
        wishlist : function(main,variant_id){
            if(typeof customer_id != typeof undefined){
                var wished = true;
                if(wishlists.indexOf(variant_id.toString()) < 0){
                    wished = false;
                }
                if(wished){
                    $(main).find('.add-wishlist i').removeClass('fa-heart-o').addClass('fa-heart');
                }else{
                    $(main).find('.add-wishlist i').addClass('fa-heart-o').removeClass('fa-heart');
                }
            }
        },
        close : function(){
            $('.close-aside').on('click',function(e){
                e.preventDefault();
                $('.aside-shop').removeClass('active');
                $('.sidebar-overlay').removeClass('active');
            })
        },
        viewCompare : function(){
            $(document).on('click','.compare',function(e){
                e.preventDefault();
                $('#modal-quick-view').modal('hide');
                var id = $(this).data('id').toString();
                var html = $(document).find('#compare-'+id).html();
                html = theme.getCompareData(id,html);
                theme.showModalCompare(html);
                theme.actionCompareId('add',id);
            });
        },
        getCompareData : function(id,html){
            var arrs = getCookie('_compare_list');
            if(arrs != false){
                arrs = arrs.split(',');
                $.each(arrs,function(i,e){
                    console.log(e);
                    if(e != id){
                        var data_html = $(document).find('#compare-' + e).html();
                        if(data_html != undefined){
                            html += data_html;
                        }
                    }
                });
                return html;
            }
            return html;
        },
        actionCompareId : function(action,id){
            var arrs = getCookie('_compare_list');
            if(action == 'add'){
                if(arrs != false) {
                    arrs = arrs.split(',');
                    if (jQuery.inArray(id, arrs) < 0) {
                        arrs.push(id);
                        setCookie('_compare_list', arrs, 60);
                    }
                }else{
                    setCookie('_compare_list',id,60);
                }
            }else{
                arrs = arrs.split(',');
                var index = arrs.indexOf(id);
                console.log(index);
                if (index > -1) {
                    arrs.splice(index, 1);
                    setCookie('_compare_list',arrs,60);
                }
            }
        },
        showModalCompare : function(html){
            var $modalCompare = $('#modal-compare');
            $('.append-owl').removeClass('owl-loaded');
            $('.append-owl').trigger('destroy.owl.carousel');
            $('.append-owl').html(html).show().owlCarousel({
                nav:false,
                responsiveClass: true,
                dots:false,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    992: {
                        items: 3
                    },
                    1200: {
                        items: 4
                    }
                }
            });
            $modalCompare.modal('show');
            $('#quick-view').modal('hide');
            $('.close-compare').on('click',function(e){
                e.preventDefault();
                $($modalCompare).modal('hide');
            })
        },
        removeCompareId : function(){
            $(document).on('click','.remove-from-compare',function(e){
                e.preventDefault();
                var id = $(this).data('id').toString();
                var html = '';
                html = theme.getCompareData(id,html);
                theme.showModalCompare(html);
                theme.actionCompareId('remove',id);
            });
        },
        relatedProduct : function(){
            $('.content-related').owlCarousel({
                nav:false,
                dots:false,
                autoplay:false,
                margin:40,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    992: {
                        items: 3
                    },
                    1200: {
                        items: 3
                    }
                }
            });
        },
        navProduct : function(){
            var big = $(document).find('.big-image').attr('id');
            var nav = $(document).find('.nav-image').attr('id');
            $('#'+big).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                //asNavFor: '#'+nav
            });
            function initSlide() {
                if($('.content-image-product').length > 0){
                    $('#'+nav).slick({
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        asNavFor: '#'+big,
                        dots: false,
                        focusOnSelect: true
                    });
                }
            }
            initSlide();
            $(window).on('resize',function(){
                $('#'+nav).slick('destroy');
                initSlide();
            })
        },
        isotopeCollection : function () {
            var collection = $('.product-view');
            //collection.data('isotope',null);
            collection.imagesLoaded(function(){
                collection.isotope({filter:'*'});
            });
        },
        box : function(){
            $('.banner').on('click',function(){
                window.location = $(this).data('href');
            })
        },
        toggleMenu : function(){
            $('.close-aside').on('click',function(){
                $('.aside-shop').removeClass('active');
            })
            if(window.pageYOffset >= 50){
                $('.main-menu').addClass('fixed-menu');
            }
            $(window).on('scroll',function(){
                var o = window.pageYOffset;
                if(o >= 50){
                    $('.main-menu').addClass('fixed-menu');
                }else{
                    $('.main-menu').removeClass('fixed-menu')
                }
            })
            $('.toggle-menu').on('click',function(e){
                e.preventDefault();
                $('.menu-responsive').toggleClass('active');
                if($('.menu-responsive').hasClass('active')){
                    $(this).find('i').removeClass('fa-bars').addClass('fa-remove');
                    $(this).addClass('toggle-active');
                }else{
                    $(this).find('i').addClass('fa-bars').removeClass('fa-remove');
                    $(this).removeClass('toggle-active');
                }
            })
            $('.search-menu a').on('click',function(){
                $('.search-form-container').toggleClass('active');
                $('.search-form-container .search-input').focus();
            })
            $('.close-form').on('click',function(){
                $('.search-form-container').removeClass('active');
            })
            $('.form-over').on('click',function(){
                $('.search-form-container').removeClass('active');
            })
            $('.menu>li').each(function(){
                var num = $(this).find('li.active').length;
                if(num > 0){
                    $(this).addClass('active');
                }
            })
            // $('.search-input').focus(function(){
            //     $('.search-form-container').addClass('active');
            // })
        },
        scroll : function(){
            $(window).on('scroll',function(){
                if(pageYOffset > 600){
                    $('.scroll-top').addClass('bounce');
                }else{
                    $('.scroll-top').removeClass('bounce');
                }
            });
            $('.scroll-top').on('click',function(){
                $("html, body").animate({ scrollTop: 0 }, "slow");
                return false;
            });
        }
    }
    theme.init();
})
if(typeof access_token != typeof undefined) {
    var social = {
        datas: {"links": [], "images": []},
        getInsImage: function (number) {
            $.ajax({
                method: 'GET',
                url: 'https://api.instagram.com/v1/users/self/media/recent?access_token=' + access_token + '&count=' + number + '&callback=?',
                error: function (response) {
                    console.log(response.message);
                },
                success: function (response) {
                    if (response.meta.code == 200) {
                        $.each(response.data, function (i, e) {
                            social.datas.links.push(e.link);
                            social.datas.images.push(e.images.standard_resolution.url);
                        });
                    }
                },
                dataType: 'jsonp'
            });
        }
    }
    Instagram = {
        init: function () {
            $('.instagram').each(function () {
                var $this = $(this);
                var id = $this.data('id');
                Instagram.build(id);
            })
        },
        build: function (id) {
            var slide = $('#instagram-' + id);
            var number = slide.data('number');
            var options = slide.data('options');
            var html = '';
            var get = setInterval(function () {
                if (social.datas.images.length > 0) {
                    clearInterval(get);
                    for (var i = 0; i < social.datas.images.length; i++) {
                        html += '<div class="item"> ' +
                            '<a target="_blank" href="' + social.datas.links[i] + '"><img width="320" height="320" src="' + social.datas.images[i] + '" alt="Instagram"></a> ' +
                            '</div>';
                    }
                    slide.html(html).addClass('owl-carousel').owlCarousel({
                        autoplay: options.autoplay,
                        nav: true,
                        loop: true,
                        navText: ['<span class="flaticon-arrows-4"></span>', '<span class="flaticon-arrows-3"></span>'],
                        autoplayTimeout: options.autoplayTimeout,
                        margin: options.margin,
                        responsive: {
                            0: {
                                items: 2
                            },
                            480: {
                                items: 3
                            },
                            768: {
                                items: 4
                            },
                            992: {
                                items: 6
                            },
                            1200: {
                                items: 9
                            }
                        }
                    });
                } else {
                    social.getInsImage(number);
                }
            }, 500);
        }
    };
    Instagram.init();
}
SlideShow = {
    init : function(){
        $('.slide-shows').each(function(){
            var id = $(this).data('id');
            SlideShow.build(id);
        })
    },
    build : function(id){
        var slide_show = $('#slide-show-'+id);
        var options = slide_show.data('options');
        slide_show.owlCarousel({
            nav:false,
            dots:false,
            loop:options.loop,
            autoplay:options.autoplay,
            autoplayTimeout:options.autoplayTimeout,
            margin:0,
            animateIn:'fadeIn',
            animateOut:'fadeOut',
            mouseDrag:false,
            items:1
        }).on('changed.owl.carousel',function(event){
            var index = event.item.index;
            var items = $(event.currentTarget).find('.owl-item');

            $(items).find('h1').removeClass('fadeInDown animated');
            $(items).find('h3').removeClass('fadeInDown animated');
            $(items).find('p').removeClass('fadeInDown animated');
            $(items).find('.button').removeClass('fadeInDown animated');

            $(items[index]).find('h1').addClass('fadeInDown animated');
            $(items[index]).find('h3').addClass('fadeInDown animated');
            $(items).find('p').removeClass('fadeInDown animated');
            $(items[index]).find('.button').addClass('fadeInDown animated');
        })
        //SlideShow.reSize();
    },
    reSize : function() {
        SlideShow.handlesize();
        $(window).on('resize', function () {
            SlideShow.handlesize();
        });
    },
    handlesize : function(){
        var owlSlide = $('.slide-show-container')[0];
        var top = $(owlSlide).position().top;
        var wh = window.innerHeight;
        console.log(top);
        if(wh > 600){
            $(owlSlide).find('.slide-image').css('height',(wh-top)+'px');
        }
    }
}
SlideShow.init();
FeaturedProduct = {
    init : function(){
        if($('.featured-product').length >0) {
            FeaturedProduct.build();
        }
    },
    build : function(){
        var slide_show = $('.featured-product');
        var options = slide_show.data('options');
        slide_show.owlCarousel({
            nav:false,
            dots:options.dots,
            loop:false,
            autoplay:options.autoplay,
            autoplayTimeout:options.autoplayTimeout,
            margin:options.margin,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 2
                },
                992: {
                    items: 3
                },
                1200: {
                    items: 4
                }
            }
        });
    }
}
FeaturedProduct.init();
BlogPost = {
    init : function(){
        $('.blog-post').each(function(){
            var id = $(this).data('id');
            BlogPost.build(id);
        })
    },
    build : function(id){
        var slide_show = $('#blog-post-'+id);
        var options = slide_show.data('options');
        slide_show.owlCarousel({
            nav:false,
            dots:false,
            loop:options.loop,
            autoplay:options.autoplay,
            autoplayTimeout:options.autoplayTimeout,
            margin:options.margin,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 2
                },
                992: {
                    items: 3
                },
                1200: {
                    items: 3
                }
            }
        });
    }
}
BlogPost.init();
AboutInformation = {
    init : function(){
        $('.image-bitmap').each(function(){
            var id = $(this).data('id');
            AboutInformation.build(id);
        })
    },
    build : function(id){
        $('#image-bitmap-parent-'+id).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            //asNavFor: '#image-bitmap-'+id
        });
        $('#image-bitmap-'+id).slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '#image-bitmap-parent-'+id,
            dots: false,
            focusOnSelect: true
        });
        setTimeout(function(){
            var h = $('.get-height-'+id).css('height');
            $('.set-height-'+id).css('height',h);
        },500)
    }
}
AboutInformation.init();
OurFarmer = {
    init : function(){
        $('.our-farmer').each(function(){
            var id = $(this).data('id');
            OurFarmer.build(id);
        })
    },
    build : function(id){
        var slide_show = $('#our-farmer-'+id);
        slide_show.owlCarousel({
            nav:false,
            dots:false,
            loop:false,
            autoplay:false,
            margin:40,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 2
                },
                992: {
                    items: 3
                },
                1200: {
                    items: 4
                }
            }
        });
    }
}
OurFarmer.init();
BrandSlide = {
    init : function(){
        $('.brand-slide').each(function(){
            var id = $(this).data('id');
            BrandSlide.build(id);
        })
    },
    build : function(id){
        var slide_show = $('#brand-slide-'+id);
        slide_show.owlCarousel({
            nav:false,
            dots:false,
            loop:false,
            autoplay:false,
            margin:30,
            responsive: {
                0: {
                    items: 2
                },
                768: {
                    items: 3
                },
                992: {
                    items: 4
                },
                1200: {
                    items: 5
                }
            }
        });
    }
}
BrandSlide.init();
ListCollection = {
    init : function(){
        if($('.list-collection-header').length > 0){
            ListCollection.build();
        }
    },
    build : function(){
        var slide_show = $('.list-collection-header');
        slide_show.owlCarousel({
            nav:false,
            dots:true,
            loop:false,
            autoplay:false,
            margin:40,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 2
                },
                992: {
                    items: 3
                },
                1200: {
                    items: 3
                }
            }
        });
    }
}
ListCollection.init();
ListBanner = {
    init : function(){
        $('.lists-banner').each(function(){
            var id = $(this).data('id');
            ListBanner.build(id);
        })
    },
    build : function(id){
        var slide_show = $('#lists-banner-'+id);
        var options = $('#lists-banner-'+id).data('options');
        slide_show.owlCarousel({
            nav:false,
            dots:false,
            loop:false,
            autoplay:false,
            margin:options == 'template-1'?0:40,
            responsive: {
                0: {
                    items: 1
                },
                480:{
                    items:1
                },
                768: {
                    items: 2
                },
                992: {
                    items: 3
                },
                1200: {
                    items: options == 'template-1'?3:4
                }
            }
        });
    }
}
ListBanner.init();
ClientSay = {
    init : function(){
        $('.lists-client-say').each(function(){
            var id = $(this).data('id');
            ClientSay.build(id);
        })
    },
    build : function(id){
        var slide_show = $('#lists-client-say-'+id);
        slide_show.owlCarousel({
            nav:false,
            dots:false,
            loop:true,
            autoplay:true,
            autoplayTimeout:5000,
            smartSpeed:2000,
            items:1
        })
    },
}
ClientSay.init();
isotopeGallery = {
    init : function(){
        $('.list-gallery').each(function(){
           var id = $(this).data('id');
           isotopeGallery.build(id)
        });
    },
    build : function(id){
        var gallery = $('#gallery-'+id);
        gallery.imagesLoaded(function(){
            gallery.isotope({filter:'*'});
        });
        $('.nav-filter-'+id+' li a').on('click',function(e){
            e.preventDefault();
            $(this).parents('li').siblings('li').removeClass('active');
            $(this).parent().addClass('active');
            var filter = $(this).data('filter');
            //gallery.imagesLoaded(function(){
            gallery.isotope({filter:filter});
            //});
        })
        lightGallery(document.getElementById('gallery-'+id), {
            thumbnail:true,
            animateThumb: false,
            showThumbByDefault: false
        });
    }
}
isotopeGallery.init();
$(document).on('shopify:section:load', function (e) {
    var data = e.target.attributes;
    var array;
    for(var i in data){
        if(data[i].nodeValue.indexOf("}") > 0){
            array = data[i].nodeValue;
            break;
        }
    }
    console.log(JSON.parse(array));
    var section = JSON.parse(array);
    ListCollection.init();
    switch (section.type){
        case 'slide-show':
            SlideShow.build(section.id);
            break;
        case 'featured-products':
            FeaturedProduct.build();
            break;
        case 'blog-post':
            BlogPost.build(section.id);
            break;
        case 'about-information':
            AboutInformation.build(section.id);
            break;
        case 'our-farmer':
            OurFarmer.build(section.id);
            break;
        case 'brand-slide':
            BrandSlide.build(section.id);
            break;
        case 'banner-collection':
            ListBanner.build(section.id);
            break;
        case 'customer-say':
            ClientSay.build(section.id);
            break;
        case 'gallery':
        case 'gallery-masonry':
            isotopeGallery.build(section.id);
            break;
    }
})
